//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { splitMentionedItemsCombiner } from '@galleries/selectors/splitMentionedItemsCombiner';
import { ICuralateStore } from '@models/AppState';
import { getHasMultiHandleInstagramEnabled } from '@account-settings/redux/facebook-instagram/selectors/getMultiHandleFeature';
import { getIsTikTokMentionedRightsEnabled } from '@uia/rights/selectors/getUIARights';
import { getTikTokAccountSettings } from '@tiktok/redux/account/selectors/getTikTokAccountSettings';
import { getTikTokUser } from '@tiktok/redux/user/selectors/getTikTokUser';

export const splitMentionedItems = createSelector(
  (state: ICuralateStore) =>
    state.galleries.requestRightsModal.materializedItems,
  (state: ICuralateStore) => state.instagram.account.defaultInstagramAccount,
  (state: ICuralateStore) =>
    state.facebookInstagramSettings.connectedInstagramAccounts,
  (state: ICuralateStore) => getHasMultiHandleInstagramEnabled(state),
  (state: ICuralateStore) => getIsTikTokMentionedRightsEnabled(state),
  (state: ICuralateStore) => getTikTokAccountSettings(state),
  (state: ICuralateStore) => getTikTokUser(state),
  splitMentionedItemsCombiner,
);
